import React from 'react';
import { formatAmount, formatMoney } from '../../../../utils/utils';
import { momentParseDate } from '../../../../helpers';
import { Link } from 'react-router-dom';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';

type Props = {
    data: any[];
    progressPending?: boolean;
    totalRows: number;
    filter: any;
    setFilter: (filter: any) => void;
    ufValue?: number
};

const SundaysDataTable = ({ 
    data, 
    progressPending, 
    totalRows,
    filter,
    setFilter,
    ufValue
}: Props) => {
    const columns = [
        {
            name: 'Fecha',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: any, index: any, column: any) => (                                   
                <span className="">
                    {momentParseDate(row.start_date)}
                </span>
            )
        },
        {
            name: 'Evento',
            selector: (row: any) => row.bank,
            sortable: false,
            cell: (row: any, index: any, column: any) => (
                <span className="">{row.event_type.name}</span>
            )
        },
        {
            name: 'Valor UF',
            sortable: false,
            cell: (row: any, index: any, column: any) => (
                <span className="">{ufValue ? formatAmount(ufValue) : ''} CLP</span>
            )
        },
        // {
        //     name: 'Viáticos',
        //     selector: (row: any) => row?.program_date,
        //     sortable: false,
        //     sortField: 'program_date',
        //     minWidth: '120px',
        //     cell: (row: any, index: any, column: any) => (
        //         <span className="">
        //             {formatMoney(row.travel_expense?.budget)}
        //         </span>
        //     )
        // },

    ]
    return (
        <div>
            <DefaultDataTable
                columns={columns}
                data={data}
                progressPending={progressPending} 
                paginationTotalRows={totalRows}                
                filter={filter} 
                setFilter={setFilter}         
                isMobileStacked={true}   
            />
        </div>
    )
}

export default SundaysDataTable
